import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { required, maxLength } from '@src/validation';
import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';

const fieldValidator = {
  name: [required, value => maxLength(value, 255)],
  naic_number: [value => maxLength(value, 64)]
};
class LenderModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value:
          props.entity[key] !== undefined && props.entity[key] !== null
            ? props.entity[key]
            : '',
        visited: false,
        error: false
      };
    });

    fields['policy_types'] =
      props.entity['policy_types'] !== undefined
        ? props.entity['policy_types']
        : [];

    console.log(fields);
    this.state = { ...fields };
  }

  onPolicyChange = (policyId, input) => {
    const policyTypes = JSON.parse(JSON.stringify(this.state.policy_types));
    if (input.checked) {
      policyTypes.push(policyId);
    } else {
      const index = policyTypes.indexOf(policyId);
      delete policyTypes[index];
    }

    this.setState({
      policy_types: [...new Set(policyTypes)]
    });
  };

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] = formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });
    postData['policy_types'] = formData['policy_types'];

    this.setState({ ...formData });

    if (isValid) {
      if (
        this.props.entity !== undefined &&
        this.props.entity.id !== undefined
      ) {
        this.props.onEdit(this.props.entity.id, postData, () =>
          this.props.toggle()
        );
      } else {
        this.props.onCreate(postData, this.props.history);
      }
    }
    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.entity.id !== undefined
              ? 'Edit Carrier'
              : 'Create New Carrier'}
          </ModalHeader>
          <div className={'position-relative'}>
            <ModalBody className={'p-4'}>
              <Row>
                <Col>
                  <LabelInput
                    name={'Name'}
                    type={'text'}
                    required={true}
                    {...this.state.name}
                    onChange={event => this.updateForm(event, 'name')}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabelInput
                    name={'NAIC Number'}
                    type={'text'}
                    {...this.state.naic_number}
                    onChange={event => this.updateForm(event, 'naic_number')}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <label>
                    <strong>Policy Types (Check all that apply)</strong>
                  </label>
                </Col>
                {Object.keys(this.props.policyTypes).map(index => {
                  return (
                    <Col xs={6} key={index}>
                      <label>
                        <input
                          type={'checkbox'}
                          checked={
                            this.state.policy_types.indexOf(
                              parseInt(index, 10)
                            ) !== -1
                          }
                          onChange={e =>
                            this.onPolicyChange(
                              parseInt(index, 10),
                              e.currentTarget
                            )
                          }
                        />{' '}
                        {this.props.policyTypes[index]}
                      </label>
                    </Col>
                  );
                })}
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}

const mapStateToProps = state => {
  return {
    loading: state.lender.loading,
    policyTypes: state.auth.policy_types
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCreate: (postData, history) =>
      dispatch(actions.createPolicyCarrier(postData, history)),
    onEdit: (entityId, postData, callback) =>
      dispatch(actions.editPolicyCarrier(entityId, postData, callback))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LenderModal);
